import { useMemo, useState } from 'react';
import { ConfigureLineContext } from './ConfigureLineContext';
import { AxiosError } from 'axios';
import { SimSelectionType } from '../../../../pages/ConfigureLine/types';

const ConfigureLineProvider = ({ children }: { children: React.ReactNode }) => {
    const [blockedLineSuccess, setBlockedLineSuccess] = useState(false);
    const [blocked, setBlocked] = useState(false);
    const [configureLineError, setConfigureLineError] = useState<AxiosError | null>(null);
    const [isConvergent, setIsConvergent] = useState(false);
    const [simTypeSelected, setSimTypeSelected] = useState<SimSelectionType>('PHYSICAL_SIM');
    const [duplicateSimSuccess, setDuplicateSimSuccess] = useState(false);
    const [blockedLines, setBlockedLines] = useState<string[]>([]);
    const [blockedLinesChecked, setBlockedLinesChecked] = useState(false);
    const [lineActive, setLineActive] = useState('');
    const [blockedLineRestrictionId, setBlockedLineRestrictionId] = useState('');
    const [eSimInstallFlow, setESimInstallFlow] = useState<'qr' | 'install'>('qr');

    const value = useMemo(
        () => ({
            blocked,
            blockedLines,
            isConvergent,
            blockedLineSuccess,
            configureLineError,
            simTypeSelected,
            duplicateSimSuccess,
            blockedLinesChecked,
            lineActive,
            blockedLineRestrictionId,
            eSimInstallFlow,
            setBlockedLineSuccess,
            setBlocked,
            setConfigureLineError,
            setIsConvergent,
            setSimTypeSelected,
            setDuplicateSimSuccess,
            setBlockedLines,
            setBlockedLinesChecked,
            setLineActive,
            setBlockedLineRestrictionId,
            setESimInstallFlow,
        }),
        [
            blockedLineSuccess,
            blocked,
            configureLineError,
            isConvergent,
            blockedLines,
            simTypeSelected,
            duplicateSimSuccess,
            blockedLinesChecked,
            lineActive,
            blockedLineRestrictionId,
            eSimInstallFlow,
        ],
    );

    return <ConfigureLineContext.Provider value={value}>{children}</ConfigureLineContext.Provider>;
};

export default ConfigureLineProvider;
